<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <v-layout row>
      <v-flex xs6 offset-xs3>
        <v-timeline align-top dense clipped>
          <v-timeline-item :color="colourForUserRead" icon="person" fill-dot>
            <v-card :color="colourForUserRead" dark>
              <v-card-title class="title">
                User
              </v-card-title>
              <v-card-text :class="ui.textCard">
                <p>user detail, setting, preferences and management.</p>
                <!-- {{ui.btnAppNavigationTopColor}} -->
                <p v-if="checkUserStatusDetails" class="warning--text body-2">
                  <v-icon color="warning"> warning </v-icon>
                  user settings are not complete !
                </p>
                 <v-btn :color="colourForUserRead"
                   :to="'/userdash'"
                   class="mx-0"
                   outline
                   small
                 >
                   view
                 </v-btn>
               </v-card-text>
             </v-card>
           </v-timeline-item>
           <v-timeline-item :color="colourForCompanyRead"
           icon="account_balance"
           fill-dot
           >
         <v-card
           :color="colourForCompanyRead"
           dark
         >
           <v-card-title class="title">
             {{displayCompanyTitle}}
             <v-spacer/>
             <v-icon>{{checkCompanyDownloadedStatusForCloudIcon}}</v-icon>
             <v-progress-circular
              v-show="enableSpinner"
              indeterminate
              :size="20"
              color="white"
              ></v-progress-circular>
           </v-card-title>
           <v-card-text class="white text--primary">
             <p>company management, including facility and user access privileges</p>
             <v-layout row>
               <!-- <div v-if="this.getUser.access.app.comp.length === 0">
                 <v-btn color="green accent-4" small :to="'/compnew'">
                  Create New
                 </v-btn>
               </div> -->
               <!-- <div v-else-if="this.getComp !== null">
                 <v-btn :color="colourForCompanyRead" small outline :to="'/compread'">
                  View
                 </v-btn>
               </div> -->
               <!-- <div v-else>
                 <v-btn
                   :color="colourForCompanyRead"
                   v-if="this.getUser.sel.cid !== ''"
                   outline
                   small
                   @click="readyp()">
                   detail
                 </v-btn>
               </div> -->
               <v-spacer/>
               <v-btn small color="besetblue" :to="'/compauth'" v-if="this.getUser.licence.auth.lvl < 2">
                 auth
               </v-btn>
               <v-spacer/>
                 <v-btn
                   color="green accent-4"
                   :to="'/compaccess'"
                   class="mx-0"
                   outline
                   small
                 >
                   select
                 </v-btn>
             </v-layout>
           </v-card-text>
         </v-card>
       </v-timeline-item>
       <v-timeline-item
         :color="colourForFacilityRead"
         icon="location_on"
         fill-dot
       >
         <v-card
           :color="colourForFacilityRead"
           dark
         >
           <v-card-title class="title">
             {{displayFacilityTitle}}
             <v-spacer/>
             <!-- <v-icon :to="'/facilityread'" v-show="!this.formUserPrefFacilityAccessExpired">{{checkFacilityDownloadedStatusForCloudIcon}}</v-icon>
             <v-icon v-if="this.userFacilityAccessBlocked === true">lock</v-icon>
             <v-icon v-if="this.formUserPrefFacilityAccessExpired === true">history_toggle_off</v-icon> -->
             <v-btn icon :to="'/facilitydashmaint'"><v-icon>build</v-icon></v-btn>
             <v-progress-circular
              v-show="enableSpinner2"
              indeterminate
              :size="20"
              color="white"
              ></v-progress-circular>
              <!-- <div v-if="this.enableSpinnerGetFacilityNotificationsDashboard === false">
                <v-btn
                  v-if="getUser.lic.auth.lvl < 3 && getFacility !== null"
                  v-show="!this.formUserPrefFacilityAccessExpired"
                  icon
                  dark
                  @click="getFacilityNotificationsLimitedBy100Dashboard()">
                  <v-icon>dashboard</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <BtnSpin :btnSpec="btnInfo4"/>
              </div> -->
           </v-card-title>
           <v-card-text class="white text--primary">
             <p>facility and user access management, asset register with inspection and test data </p>
             <v-layout row>
               <div v-if="this.getFacility !== null">
                 <v-btn :color="colourForFacilityRead" small outline :to="'/facilityread'">
                  View
                 </v-btn>
               </div>
               <div v-else-if="this.getUser.select.fid === '' && this.getComp === null">
                 <v-btn dark color="warning" small @click="readyp()">
                  Download Company
                 </v-btn>
               </div>
               <div v-else-if="this.getUser.licence.auth.lvl < 2 && this.getComp !== null">
                 <v-btn color="green accent-4" small :to="'/facilitynew'">
                  Create New
                 </v-btn>
               </div>
               <div v-else>
                 <v-btn
                   v-if="this.getUser.select.fname !== ''"
                   :color="colourForFacilityRead"
                   outline
                   small
                   @click="readFacility()">
                   details
                 </v-btn>
               </div>
               <v-spacer/>
                 <v-btn
                   color="green accent-4"
                   :to="'/facilityregister'"
                   class="mx-0"
                   outline
                   small
                 >
                   access
                 </v-btn>
                 <v-btn
                   color="green accent-4"
                   :to="'/facilityaccess'"
                   class="mx-0"
                   outline
                   small
                 >
                   select
                 </v-btn>
             </v-layout>
           </v-card-text>
         </v-card>
       </v-timeline-item>
      </v-timeline>
    </v-flex>
  </v-layout>

  <AppNavigationBottom/>

</div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
// import BtnSpin from "@/frame/animation/components/BtnSpin";
import currentPage from "@/frame/pages/mixins/currentPage.js";
// import userAccess from "@/foundations/user/mixins/userAccess.js";
import generalFunctions from "@/globals/mixins/generalFunctions.js";
import { mapGetters } from "vuex";
// import getAssetNotifications from "@/management/general/mixins/getAssetNotifications.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  components: {
    AppNavigationBottom,
    // BtnSpin,
    AppNavigationTop
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme,
    generalFunctions
    // getAssetNotifications,
  ],
  data() {
    return {
      enableSpinner: false,
      enableSpinner2: false,
      enableSpinner3: false,
      progresBarSpin: false,
      enableSpinnerGetFacilityNotificationsDashboard: false,
      currentPagePath: "/welcomehome",
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "outline"
      },
      btnInfo2: {
        color: "red",
        icon: "assignment",
        name: "detail",
        btnType: "flat"
      },
      btnInfo3: {
        color: "red",
        icon: "assignment",
        name: "detail",
        btnType: "flat"
      },
      btnInfo4: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      AppNavigationTopInfo: {
        btns: [
          {
            title: "user",
            icon: "person",
            link: "/usersettingsread"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      },
      AppNavigationTopUser: {
        title: "username",
        titleColour: "besetblue--text",
        btns: [
          {
            title: "app",
            icon: "apps",
            link: "/appsmenu"
          },
          {
            title: "user",
            icon: "person",
            link: "/usersettingsread"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      }
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser", "getComp", "getFacility", "getAsset", "getAssetsSearched", "getCurrentPage", "getPreviousPage"]),
    iconTypeForUserRead() {
      if (this.getUser !== null) {
        return "done";
      } else {
        return "warning";
      }
    },
    iconTypeForCompanyRead() {
      if (this.getUser !== null) {
        return "done";
      } else {
        return "warning";
      }
    },
    iconTypeForFacilityRead() {
      if (this.getUser !== null) {
        return "done";
      } else {
        return "warning";
      }
    },
    colourForUserRead() {
      if (this.getUser.basic.namef === "" || this.getUser.basic.names === "") {
        return "green accent-3";
      } else {
        return "green accent-4";
      }
    },
    colourForUserReadX() {
      if (this.getUser.basic.namef === "" || this.getUser.basic.names === "") {
        return this.ui.colorSuccess;
      } else {
        return this.ui.colorSuccess;
      }
    },
    colourForCompanyRead() {
      if (this.getUser.pref.select.cname === "") {
        return "red accent-3";
      } else {
        return "green accent-4";
      }
    },
    colourForFacilityRead() {
      if (this.getUser.select.fname === "") {
        return "red accent-3";
      } else if (this.formUserPrefFacilityAccessExpired === true) {
        return "warning";
      } else if (this.userFacilityAccessBlocked === true) {
        return "warning";
      } else {
        return "green accent-4";
      }
    },
    checkUserStatusDetails() {
      if (this.getUser.basic.namef === "" || this.getUser.basic.names === "") {
        return true;
      } else {
        return false;
      }
    },
    checkCompanyDownloadedStatusForCloudIcon() {
      if (this.getComp !== null) {
        return "cloud";
      } else {
        return "";
      }
    },
    checkFacilityDownloadedStatusForCloudIcon() {
      if (this.getFacility !== null) {
        return "cloud";
      } else {
        return "";
      }
    },
    checkCompanySelectionStatus() {
      if (this.getUser.pref.select.cname === "") {
        return true;
      } else {
        return false;
      }
    },
    displayCompanyTitle() {
      if (this.getUser.pref.select.cname !== "") {
        return this.getUser.pref.select.cname;
      } else {
        return "Select Company";
      }
    },
    displayFacilityTitle() {
      if (this.getUser.select.fname !== "") {
        return this.getUser.select.fname;
      } else {
        return "Select Facility";
      }
    },
    iconColourForCompanyRead() {
      if (this.getComp !== null) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    iconColourForFacilityRead() {
      if (this.getFacility !== null) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    // eslint-disable-next-line
    iconColourForCompanyAuth() {
      // eslint-disable-next-line
      if (this.getUser.pref.select.cname !== "" && this.getUser.licence.auth.lvl < 2) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    iconColourForCompanyUsers() {
      if (this.getComp !== null && this.getUser.licence.auth.lvl < 2) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    iconColourForFacilityUsers() {
      if (this.getFacility !== null && this.getUser.licence.auth.lvl < 3) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    // eslint-disable-next-line
    iconColourForFacilityAccessReview() {
      // eslint-disable-next-line
      if (this.getUser.select.fname !== "" && this.getUser.licence.auth.lvl < 3) {
        return "indigo";
      } else {
        return "grey";
      }
    },
    iconColourForCompanyFacty() {
      if (this.getComp !== null && this.getUser.licence.auth.lvl < 2) {
        return "indigo";
      } else {
        return "grey";
      }
    }
  },
  methods: {
    readypLocal() {
      this.enableSpinner = true;
    },
    goToAssetDetail() {
      // this.progresBarSpin = true;
      this.$router.push("/assetread");
    },
    goToCompanySelection() {
      // this.progresBarSpin = true;
      this.$router.push("/compaccess");
    },
    goToFacilitySelection() {
      // this.progresBarSpin = true;
      this.$router.push("/facilityaccess");
    },
    goToCompanyAuthority() {
      // this.progresBarSpin = true;
      // eslint-disable-next-line
      if (this.getUser.pref.select.cname !== "" && this.getUser.licence.auth.lvl < 2) {
        this.$router.push("/compauth");
      }
    },
    goToCompanyEdit() {
      // this.progresBarSpin = true;
      // eslint-disable-next-line
      if (this.getUser.pref.select.cname !== "" && this.getUser.licence.auth.lvl < 2) {
        this.$router.push("/compauth");
      }
    },
    goToCompanyRead() {
      // company must be selected
      if (this.getComp !== null) {
        this.$router.push("/compread");
      }
    },
    goToFacilityRead() {
      // company must be selected
      if (this.getFacility !== null) {
        this.$router.push("/facilityread");
      }
    },
    goToCompanyUsers() {
      // this.progresBarSpin = true;
      if (this.getComp !== null && this.getUser.licence.auth.lvl < 2) {
        this.$router.push("/compusers");
      }
    },
    goToFacilityUsers() {
      // this.progresBarSpin = true;
      if (this.getFacility !== null && this.getUser.licence.auth.lvl < 3) {
        this.$router.push("/facilityusers");
      }
    },
    goToFacilityAccessReview() {
      // this.progresBarSpin = true;
      // eslint-disable-next-line
      if (this.getUser.pref.select.cname !== "" && this.getUser.licence.auth.lvl < 3) {
        this.$router.push("/facilityaccessreview");
      }
    },
    goToCompanyFacilities() {
      // this.progresBarSpin = true;
      if (this.getComp !== null && this.getUser.licence.auth.lvl < 2) {
        this.$router.push("/compfacty");
      }
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
  }
};
</script>
